import React from 'react';
import { APIMetadata } from '../../services/model';
import grafanaLogo from '../../assets/grafana_icon.svg';

type APIProps = { metadata: APIMetadata; isInternal: boolean };

export const API: React.FC<APIProps> = ({ isInternal, metadata }) => {
    const detailPageRoute = metadata.legacy
        ? `/documentation/${metadata.identifier}`
        : `/documentation/${metadata.identifier}/version/${metadata.apiVersion}`;

    const handleOnClick = (e) => {
        if (!e.target.className.includes('argus-dashboard') && !e.target.closest('.argus-dashboard')) {
            window.location.assign(detailPageRoute);
        }
    };

    const handleLinkClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(metadata.argusDashboardUrl);
    };

    return (
        <tr className="selectable" onClick={handleOnClick} title={metadata.identifier}>
            <th scope="row">{metadata.title}</th>
            <td>{metadata.description}</td>
            {isInternal && (
                <td title="Link to Argus dashboard" onClick={handleLinkClick} className="argus-dashboard">
                    <a href={metadata.argusDashboardUrl}>
                        <img src={grafanaLogo} alt="argus_dashboard_url" style={{ height: '20px', width: '21px' }} />
                    </a>
                </td>
            )}
            <td>{metadata.apiVersion !== 'unversioned' ? metadata.apiVersion : ''}</td>
        </tr>
    );
};
